<script lang="ts" setup>
import {withoutFragment} from "ufo";
import type {LocaleObject} from "@nuxtjs/i18n/dist/module";
import {useMagnoliaLanguages} from "#magnolia-layer/composables/use-magnolia-languages";

const {locales, locale: currentLocale} = useI18n();
const switchLocalePath = useSwitchLocalePath();
const languages = useMagnoliaLanguages();

const availableLocales = computed(() => {
  return (locales.value as LocaleObject[]).filter((locale) => {
    return languages.includes(locale.code);
  });
});
</script>
<template>
  <ul v-if="availableLocales.length > 1" class="language-selector text-l gap-4 mt-8 flex flex-col w-fit sm:w-full">
    <li
      v-for="(locale, index) in availableLocales"
      :key="locale.code"
      :class="{'is-current': locale.code === currentLocale}">
      <NuxtLink
        :hreflang="locale.code"
        :to="withoutFragment(switchLocalePath(locale.code))"
        rel="alternate">
        {{ locale.code }}
      </NuxtLink>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.language-selector {
  text-transform: uppercase;
  display: flex;
  flex-direction: row;

  a {
    color: var(--color-white);
    text-decoration: none;

    transition: all 0.3s ease;

    &:hover {
      color: var(--color-sunrise-100);
      opacity: 1;
    }
  }

  li a {
    opacity: 0.6;
  }

  .is-current a {
    opacity: 1;
  }
}
</style>
